//@ts-nocheck
import React, { useState, useEffect, } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { format, formatDistanceToNow } from 'date-fns';
import { fetchAppJourneyData1 } from '../../features/AppReview/AppReviewSlice';
import { ExclamationIcon } from '../icons';
import { toast } from 'sonner';
import { getColorForLabel } from '../../utils/colorUtils';

const getStageName = (stageId: any) => {
  // Get scorecard data from localStorage
  const scorecardData = JSON.parse(localStorage.getItem("jobPipelineStageData") || "{}");
  const stages = scorecardData?.stages || [];

  // Find the stage with matching ID
  const stage = stages.find((stage: any) => stage.id === stageId);
  return stage ? stage.stage_name : null;
};

const getStageColor = (stageId: any) => {
  // Get scorecard data from localStorage
  const scorecardData = JSON.parse(localStorage.getItem("jobPipelineStageData") || "{}");
  const stages = scorecardData?.stages || [];

  // Find the stage with matching ID
  const stage = stages.find((stage: any) => stage.id === stageId);
  return stage ? stage.stage_colour : null;
}





function Journey({ applicationDetails, job: jobProp, app: appProp, quickData }: any) {  
  // const { baseId, applicationId, } = useParams<{ baseId: string; jobId: string; applicationId: string; skillId: string }>();
  const { baseId, jobId: jobIdFromParams, applicationId: applicationIdFromParams, skillId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
    skillId: string
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData

  const dispatch = useAppDispatch();
  const [openMeeting, setOpenMeeting] = useState(false);

  // Local state for meetings data
  const [meetingList, setMeetingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];



  // Fetch meetings when component mounts
  useEffect(() => {
    if (baseId && applicationId) { // Ensure both baseId and appId are available
      setLoading(true);
      dispatch(fetchAppJourneyData1({ baseId: parseInt(baseId), appId: applicationId })) // Pass an object with baseId and appId
        .unwrap()
        .then((response) => {

          setMeetingList(response.data.journey); // Set the data array from response
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching meetings:", error);
          setError(error.toString());
          setLoading(false);
        });
    }
  }, [dispatch, baseId, applicationId]);

  const handleMeeting = () => {
    setOpenMeeting(true);
  };

  const darkenColor = (color: string, amount = 40) => {
  const num = parseInt(color.replace("#", ""), 16)
  let r = (num >> 16) - amount
  let g = ((num >> 8) & 0x00ff) - amount
  let b = (num & 0x0000ff) - amount

  r = r < 0 ? 0 : r
  g = g < 0 ? 0 : g
  b = b < 0 ? 0 : b

  return `rgb(${r}, ${g}, ${b})`
}

  return (
    <div>
      {/* <div className='flex items-center justify-between'>
        <h2 className="text-[18px] lg:text-[18px] font-medium leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">App Review</h2>
        <button
          onClick={handleMeeting}
          className="group inline-flex shrink-0 select-none items-center justify-end text-sm font-medium leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-[8px] py-1 rounded-md text-white bg-indigo-600 h-[24px] hover:bg-indigo-500 focus-visible:outline-indigo-600"
          type="button"
        >
          <div className="flex items-center gap-[6px]">Create App Review</div>
        </button>
      </div> */}
      {/* <div className='bg-[#e0e0e0] w-full h-[1px] my-6'></div> */}

      {/* Loading state */}
      {loading && (
        <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 191px)' }}>
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      )}

      {/* Error state
      {error && (
        <div className="text-center py-4 text-red-500">
          Error: {error}
        </div>
      )} */}

      {/* No meetings state */}
      {!loading && !error && (!meetingList || meetingList.length === 0) && (
        <div className='w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3'>
          <ExclamationIcon />
          <p className='text-[#0000007a] text-[13px]'>No results found</p>
        </div>
      )}

      {/* Meeting list */}
      {!loading && !error && meetingList && meetingList.length > 0 && (
        <div className="space-y-4">
          {meetingList.map((meeting, index) => {

            const senderUser = baseMembers.find(member => member.user_id === meeting.created_by) || {};
            const senderImg = senderUser.profile_pic || null;
            const senderName = senderUser.name || null;
            const appStageName = meeting.stage_id ? getStageName(meeting.stage_id) : '';
            const appStateColor = meeting.stage_id ? getStageColor(meeting.stage_id) : '';
            return (
              <div key={meeting.id} className='rounded-md p-4 cursor-pointer ring-1 ring-gray-200 feedback-delete-hover'>
                <div className='flex items-start'>
                  <div className='flex flex-row gap-x-2 items-center justify-between w-full'>
                    <div className='flex items-center gap-x-2'>
                      <div className=''>

                        {
                          senderImg ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${senderImg}`}
                              alt={`${meeting?.review_name || 'Profile'}`}
                              className="h-6 w-6 flex-none rounded-full ring-1 ring-gray-900/10"
                            />
                          ) : (
                            <div style={{ backgroundColor: getColorForLabel(senderName?.charAt(0) || '') }}
                              className="w-6 h-6 rounded-full flex items-center justify-center">
                              <span className="font-medium text-white text-[12px]"
                              >{senderName?.charAt(0) || 'V'}</span>
                            </div>
                          )
                        }

                      </div>
                      <div className='[95%] mt-[0px]'>
                        <div className='flex items-center gap-x-2'>
                          {
                            senderName &&
                            <div className='text-[12px] text-[#374151] font-medium leading-5 capitalize'>{senderName}</div>
                          }
                          {
                            meeting.created_at &&
                            <span className="flex items-center gap-x-[6px] text-xs leading-5 text-gray-500">
                              <span className="flex h-[4px] w-[4px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-[#6b7280]"></span>
                              {formatDistanceToNow(new Date(meeting.created_at), { addSuffix: true, includeSeconds: true })
                                .replace("about ", "")
                                .replace("less than ", "")
                                .replace("half a ", "1 ")
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                    {meeting.stage_id && (
                      <div
                        className='flex gap-x-1 items-center rounded-md px-2 py-1 text-xs font-medium text-gray-600 border-solid w-fit'
                        style={{
                          backgroundColor: appStateColor ? `${appStateColor}20` : 'bg-gray-50', // Add 1A for 10% opacity
                          color: appStateColor ? darkenColor(appStateColor, 90)  : 'text-gray-600',
                          // borderColor: appStateColor || 'border-gray-500/10'
                           border: `1px solid ${appStateColor}`,
                        }}
                      >
                        {appStageName}
                      </div>
                    )}
                  </div>


                </div>
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
}

export default Journey;